// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hn_BLj42Zy4SDN3FH9sP {
  animation: IRiAx7zv27zmdV8kjj2c 0.7s;
  background: white;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
  border-radius: 5px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
  min-width: 250px;
  transition: transform 0.6s ease-in-out;
}

.mZgV_DuP1iiRS7PMd52D {
  bottom: 12px;
  max-height: calc(100vh - 24px);
  overflow-x: hidden;
  overflow-y: scroll;
  position: fixed;
  right: 32px;
  scrollbar-color: rgb(0 0 0 / 10%) transparent; /* thumb and track color */
  scrollbar-width: thin;
  width: 33%;
  z-index: 50;
}

.mZgV_DuP1iiRS7PMd52D::-webkit-scrollbar {
  width: 5px;  /* for vertical scrollbars */
}

.mZgV_DuP1iiRS7PMd52D::-webkit-scrollbar-thumb {
  background: rgb(0 0 0 / 10%);
  border-radius: 5px;
}

.mZgV_DuP1iiRS7PMd52D .hn_BLj42Zy4SDN3FH9sP + .hn_BLj42Zy4SDN3FH9sP {
  margin-top: 16px;
}

.M3rk47BZD5Xdje9p0GIA {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
}

.qgGeRA2fmNoEK7rGPDJH {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
}

.sZOBsK072wlpKov0RleA {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
  margin: 0;
}

.tBq37QkCJtVgL_5Tz7la {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.tBq37QkCJtVgL_5Tz7la .jS82qdQtuqBUUXUQBIko {
  font-size: 18px;
}

.xuYYwTb06839H_AA9QQE {
  border-radius: 5px 5px 0 0;
  height: 4px;
}

.l4T18Y8XnY78ayTqIja_ {
  animation: tKyDPLs3S_l0CpxyV_dQ 0.7s;
  opacity: 0;
  transition: transform 0.6s ease-in-out;
}

.y0CeTXAPTbt9vXuGg2wf {
  margin: 0 16px;
}

@keyframes IRiAx7zv27zmdV8kjj2c {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes tKyDPLs3S_l0CpxyV_dQ {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  to {
    opacity: 0;
    transform: translateX(100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Toasts/Toasts.module.css"],"names":[],"mappings":"AAGA;EACE,oCAA8B;EAC9B,iBAAiB;EACjB,8DAAkC;EAClC,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,6CAA6C,EAAE,0BAA0B;EACzE,qBAAqB;EACrB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU,GAAG,4BAA4B;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mDAAwB;EACxB,SAAS;AACX;;AAEA;EACE,mDAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,oCAA+B;EAC/B,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF","sourcesContent":["@value colors: \"../style/colors.css\";\n@value color-gray-light, color-text-subtle from colors;\n\n.toast {\n  animation: toast-in-right 0.7s;\n  background: white;\n  border: 1px solid color-gray-light;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgb(0 0 0 / 10%);\n  min-width: 250px;\n  transition: transform 0.6s ease-in-out;\n}\n\n.toastContainer {\n  bottom: 12px;\n  max-height: calc(100vh - 24px);\n  overflow-x: hidden;\n  overflow-y: scroll;\n  position: fixed;\n  right: 32px;\n  scrollbar-color: rgb(0 0 0 / 10%) transparent; /* thumb and track color */\n  scrollbar-width: thin;\n  width: 33%;\n  z-index: 50;\n}\n\n.toastContainer::-webkit-scrollbar {\n  width: 5px;  /* for vertical scrollbars */\n}\n\n.toastContainer::-webkit-scrollbar-thumb {\n  background: rgb(0 0 0 / 10%);\n  border-radius: 5px;\n}\n\n.toastContainer .toast + .toast {\n  margin-top: 16px;\n}\n\n.content {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 16px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.description {\n  color: color-text-subtle;\n  margin: 0;\n}\n\n.button {\n  color: color-text-subtle;\n}\n\n.button .icon {\n  font-size: 18px;\n}\n\n.time {\n  border-radius: 5px 5px 0 0;\n  height: 4px;\n}\n\n.hideToast {\n  animation: toast-out-right 0.7s;\n  opacity: 0;\n  transition: transform 0.6s ease-in-out;\n}\n\n.textContainer {\n  margin: 0 16px;\n}\n\n@keyframes toast-in-right {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes toast-out-right {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../style/colors.css"`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"toast": `hn_BLj42Zy4SDN3FH9sP`,
	"toast-in-right": `IRiAx7zv27zmdV8kjj2c`,
	"toastContainer": `mZgV_DuP1iiRS7PMd52D`,
	"content": `M3rk47BZD5Xdje9p0GIA`,
	"title": `qgGeRA2fmNoEK7rGPDJH`,
	"description": `sZOBsK072wlpKov0RleA`,
	"button": `tBq37QkCJtVgL_5Tz7la`,
	"icon": `jS82qdQtuqBUUXUQBIko`,
	"time": `xuYYwTb06839H_AA9QQE`,
	"hideToast": `l4T18Y8XnY78ayTqIja_`,
	"toast-out-right": `tKyDPLs3S_l0CpxyV_dQ`,
	"textContainer": `y0CeTXAPTbt9vXuGg2wf`
};
export default ___CSS_LOADER_EXPORT___;
